import { useDisclosure } from '@mantine/hooks';
import { useRef } from 'react';

export const useDebounceDisclosure = (wait = 150) => {
  const [opened, { close, open }] = useDisclosure();
  const timer = useRef(null);
  const debouncedClose = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      close();
    }, wait);
  };
  const debouncedOpen = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    open();
  };
  return [
    opened,
    {
      close: debouncedClose,
      open: debouncedOpen,
    },
  ];
};
